export const AREAS = ["Site", "Camp"];

// AGUP2 is now an IT-only ticketing system. Categories are area-specific.
export const CATEGORIES_BY_AREA = {
  Site: [
    "Internet Connection Issue",
    "IT Material Request",
    "PC Maintenance",
    "Access Control Problem",
    "Printer & Toner Issue",
    "SIM Card Quota Problem",
    "Radio Range",
  ],
  Camp: [
    "TV Channel Connection Issue",
    "Internet Problem",
    "Turnstile Fault",
    "TV Connection Support",
  ],
};

// Union list (Site first, then Camp). Used by admin category filter + dashboard bars.
export const CATEGORIES = Array.from(
  new Set([...CATEGORIES_BY_AREA.Site, ...CATEGORIES_BY_AREA.Camp])
);

export const PRIORITIES = ["Normal", "Urgent"];

export const STATUSES = [
  "Received",
  "Assigned",
  "In Progress",
  "Resolved",
  "Waiting User Confirmation",
  "Closed",
];

export const IT_DEPARTMENT = "IT / Information Technology";

// Full department list — kept so legacy tickets in the DB remain editable by
// Super Admin and so the admin Department filter still works for historical
// data. New tickets always route to IT_DEPARTMENT.
export const DEPARTMENTS = [
  IT_DEPARTMENT,
  "Accommodation / Camp Admin",
  "Camp Management / Security",
  "Cleaning",
  "General Management",
  "Maintenance",
];

export const STATUS_STYLES = {
  Received: "bg-slate-100 text-slate-800 border border-slate-200",
  Assigned: "bg-blue-50 text-blue-800 border border-blue-200",
  "In Progress": "bg-amber-50 text-amber-800 border border-amber-200",
  Resolved: "bg-emerald-50 text-emerald-800 border border-emerald-200",
  "Waiting User Confirmation": "bg-violet-50 text-violet-800 border border-violet-200",
  Closed: "bg-zinc-100 text-zinc-700 border border-zinc-200",
};

export const PRIORITY_STYLES = {
  Normal: "bg-slate-100 text-slate-700 border border-slate-200",
  Urgent: "bg-red-50 text-red-700 border border-red-200",
};

/**
 * Compose a single-line "location" display from the structured fields a
 * ticket may carry. Falls back to the raw `location` field when the
 * structured fields are not present (legacy tickets).
 */
export function composeLocation(t) {
  if (!t) return "";
  if (t.area === "Camp") {
    const parts = [t.location, t.block, t.room].filter(Boolean);
    return parts.join(" / ");
  }
  if (t.area === "Site") {
    const parts = [t.location, t.office, t.requester_department].filter(Boolean);
    return parts.join(" / ");
  }
  return t.location || "";
}
